import { render, staticRenderFns } from "./MatchPayReturnStep.vue?vue&type=template&id=2fd2725b"
import script from "./MatchPayReturnStep.vue?vue&type=script&lang=js"
export * from "./MatchPayReturnStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports